export enum FilterType {
  text = 'text',
  slider = 'slider',
  radio = 'radio',
  select = 'select',
  date_picker = 'date_picker',
}
